import Vue from 'vue';

const Log = Vue.log({ context: { location: 'tracking' } });

export function trackEvent(event) {
    if (globals.config.debug || !window.dataLayer) {
        Log.debug('Event tracked', event);
    } else {
        window.dataLayer.push(event);
    }
}
